var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 37 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("circle", {
        attrs: { cx: "18.7773", cy: "18", r: "18", fill: "#E47841" },
      }),
      _c("path", {
        attrs: {
          d: "M27.8141 10.9708L27.5169 10.6736L23.6198 6.77651C23.6198 6.77651 23.6194 6.77613 23.619 6.77613L23.3226 6.47968C23.1879 6.34419 23.0007 6.2666 22.8096 6.2666H11.607C11.0828 6.2666 10.6562 6.69275 10.6562 7.21733V21.3207V27.7041C10.6562 28.2287 11.0828 28.6548 11.607 28.6548H27.0757C27.5999 28.6548 28.0264 28.2287 28.0264 27.7041V21.3207V11.4834C28.0264 11.2901 27.9512 11.1082 27.8141 10.9708ZM26.6503 10.8986H23.3944V7.6427L26.6503 10.8986ZM27.2544 27.7041C27.2544 27.8025 27.1741 27.8828 27.0757 27.8828H11.607C11.5085 27.8828 11.4283 27.8025 11.4283 27.7041V22.0928H27.2544V27.7041ZM11.4283 21.3207V7.21733C11.4283 7.1189 11.5085 7.03861 11.607 7.03861H22.6448C22.632 7.08725 22.6224 7.13743 22.6224 7.18992V11.6707H27.1035C27.1556 11.6707 27.2058 11.661 27.2544 11.6483V21.3207H11.4283Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M15.317 25.7067H15.7868C15.9906 25.7067 16.1774 25.6769 16.3461 25.6171C16.5148 25.5573 16.6592 25.4728 16.7788 25.3639C16.8985 25.255 16.9915 25.1203 17.0587 24.9601C17.1255 24.7999 17.159 24.6216 17.159 24.4244C17.159 24.2379 17.1193 24.07 17.0401 23.9202C16.961 23.7705 16.8572 23.6431 16.7286 23.5377C16.6001 23.4323 16.455 23.3528 16.2932 23.3003C16.1315 23.2474 15.9678 23.2212 15.8026 23.2212H14.6836V27.1106H15.317V25.7067V25.7067ZM15.317 23.7014H15.7918C15.9535 23.7014 16.0836 23.7269 16.1824 23.7778C16.2809 23.8288 16.3573 23.8921 16.4121 23.9677C16.4665 24.0434 16.5024 24.1225 16.5202 24.2051C16.5376 24.2877 16.5464 24.3607 16.5464 24.424C16.5464 24.5822 16.5271 24.715 16.4885 24.8223C16.4496 24.9296 16.399 25.013 16.3357 25.0729C16.2724 25.1327 16.2029 25.1759 16.1272 25.2022C16.0516 25.2284 15.9748 25.2419 15.8976 25.2419H15.317V23.7014V23.7014Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M18.508 25.7067H18.9778C19.1816 25.7067 19.3684 25.6769 19.5371 25.6171C19.7058 25.5573 19.8502 25.4728 19.9698 25.3639C20.0895 25.255 20.1825 25.1203 20.2497 24.9601C20.3165 24.7999 20.3501 24.6216 20.3501 24.4244C20.3501 24.2379 20.3103 24.07 20.2312 23.9202C20.152 23.7705 20.0482 23.6431 19.9197 23.5377C19.7911 23.4323 19.646 23.3528 19.4842 23.3003C19.3225 23.2474 19.1588 23.2212 18.9936 23.2212H17.875V27.1106H18.5084V25.7067H18.508ZM18.508 23.7014H18.9828C19.1446 23.7014 19.2746 23.7269 19.3735 23.7778C19.4719 23.8288 19.5483 23.8921 19.6031 23.9677C19.6576 24.0434 19.6935 24.1225 19.7112 24.2051C19.7286 24.2877 19.7375 24.3607 19.7375 24.424C19.7375 24.5822 19.7182 24.715 19.6796 24.8223C19.6406 24.9296 19.59 25.013 19.5267 25.0729C19.4634 25.1327 19.3939 25.1759 19.3183 25.2022C19.2426 25.2284 19.1658 25.2419 19.0886 25.2419H18.508V23.7014V23.7014Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M22.0201 27.1106H22.6589V23.6539H23.8196V23.2212H20.8594V23.6539H22.0201V27.1106Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M16.0581 13.9873C16.2714 13.9873 16.4443 13.8144 16.4443 13.6011C16.4443 13.3878 16.2714 13.2148 16.0581 13.2148C15.8448 13.2148 15.6719 13.3878 15.6719 13.6011C15.6719 13.8144 15.8448 13.9873 16.0581 13.9873Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M16.0581 17.0747C16.2714 17.0747 16.4443 16.9018 16.4443 16.6885C16.4443 16.4752 16.2714 16.3022 16.0581 16.3022C15.8448 16.3022 15.6719 16.4752 15.6719 16.6885C15.6719 16.9018 15.8448 17.0747 16.0581 17.0747Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M16.0581 15.5313C16.2714 15.5313 16.4443 15.3583 16.4443 15.145C16.4443 14.9317 16.2714 14.7588 16.0581 14.7588C15.8448 14.7588 15.6719 14.9317 15.6719 15.145C15.6719 15.3583 15.8448 15.5313 16.0581 15.5313Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M16.8315 14.7588C17.0449 14.7588 17.2178 14.5859 17.2178 14.3726C17.2178 14.1593 17.0449 13.9863 16.8315 13.9863C16.6182 13.9863 16.4453 14.1593 16.4453 14.3726C16.4453 14.5859 16.6182 14.7588 16.8315 14.7588Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M17.605 13.9873C17.8183 13.9873 17.9912 13.8144 17.9912 13.6011C17.9912 13.3878 17.8183 13.2148 17.605 13.2148C17.3917 13.2148 17.2188 13.3878 17.2188 13.6011C17.2188 13.8144 17.3917 13.9873 17.605 13.9873Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M16.8315 16.3032C17.0449 16.3032 17.2178 16.1303 17.2178 15.917C17.2178 15.7037 17.0449 15.5308 16.8315 15.5308C16.6182 15.5308 16.4453 15.7037 16.4453 15.917C16.4453 16.1303 16.6182 16.3032 16.8315 16.3032Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M17.605 17.0747C17.8183 17.0747 17.9912 16.9018 17.9912 16.6885C17.9912 16.4752 17.8183 16.3022 17.605 16.3022C17.3917 16.3022 17.2188 16.4752 17.2188 16.6885C17.2188 16.9018 17.3917 17.0747 17.605 17.0747Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M17.605 15.5313C17.8183 15.5313 17.9912 15.3583 17.9912 15.145C17.9912 14.9317 17.8183 14.7588 17.605 14.7588C17.3917 14.7588 17.2188 14.9317 17.2188 15.145C17.2188 15.3583 17.3917 15.5313 17.605 15.5313Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M18.3745 14.7588C18.5878 14.7588 18.7608 14.5859 18.7608 14.3726C18.7608 14.1593 18.5878 13.9863 18.3745 13.9863C18.1612 13.9863 17.9883 14.1593 17.9883 14.3726C17.9883 14.5859 18.1612 14.7588 18.3745 14.7588Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.144 13.9873C19.3574 13.9873 19.5303 13.8144 19.5303 13.6011C19.5303 13.3878 19.3574 13.2148 19.144 13.2148C18.9307 13.2148 18.7578 13.3878 18.7578 13.6011C18.7578 13.8144 18.9307 13.9873 19.144 13.9873Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M18.3745 16.3032C18.5878 16.3032 18.7608 16.1303 18.7608 15.917C18.7608 15.7037 18.5878 15.5308 18.3745 15.5308C18.1612 15.5308 17.9883 15.7037 17.9883 15.917C17.9883 16.1303 18.1612 16.3032 18.3745 16.3032Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.144 17.0747C19.3574 17.0747 19.5303 16.9018 19.5303 16.6885C19.5303 16.4752 19.3574 16.3022 19.144 16.3022C18.9307 16.3022 18.7578 16.4752 18.7578 16.6885C18.7578 16.9018 18.9307 17.0747 19.144 17.0747Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.144 15.5313C19.3574 15.5313 19.5303 15.3583 19.5303 15.145C19.5303 14.9317 19.3574 14.7588 19.144 14.7588C18.9307 14.7588 18.7578 14.9317 18.7578 15.145C18.7578 15.3583 18.9307 15.5313 19.144 15.5313Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.9214 14.7588C20.1347 14.7588 20.3076 14.5859 20.3076 14.3726C20.3076 14.1593 20.1347 13.9863 19.9214 13.9863C19.7081 13.9863 19.5352 14.1593 19.5352 14.3726C19.5352 14.5859 19.7081 14.7588 19.9214 14.7588Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M20.6909 13.9873C20.9042 13.9873 21.0772 13.8144 21.0772 13.6011C21.0772 13.3878 20.9042 13.2148 20.6909 13.2148C20.4776 13.2148 20.3047 13.3878 20.3047 13.6011C20.3047 13.8144 20.4776 13.9873 20.6909 13.9873Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.9214 16.3032C20.1347 16.3032 20.3076 16.1303 20.3076 15.917C20.3076 15.7037 20.1347 15.5308 19.9214 15.5308C19.7081 15.5308 19.5352 15.7037 19.5352 15.917C19.5352 16.1303 19.7081 16.3032 19.9214 16.3032Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M20.6909 17.0747C20.9042 17.0747 21.0772 16.9018 21.0772 16.6885C21.0772 16.4752 20.9042 16.3022 20.6909 16.3022C20.4776 16.3022 20.3047 16.4752 20.3047 16.6885C20.3047 16.9018 20.4776 17.0747 20.6909 17.0747Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M20.6909 15.5313C20.9042 15.5313 21.0772 15.3583 21.0772 15.145C21.0772 14.9317 20.9042 14.7588 20.6909 14.7588C20.4776 14.7588 20.3047 14.9317 20.3047 15.145C20.3047 15.3583 20.4776 15.5313 20.6909 15.5313Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M21.4644 14.7588C21.6777 14.7588 21.8506 14.5859 21.8506 14.3726C21.8506 14.1593 21.6777 13.9863 21.4644 13.9863C21.251 13.9863 21.0781 14.1593 21.0781 14.3726C21.0781 14.5859 21.251 14.7588 21.4644 14.7588Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M22.2378 13.9873C22.4511 13.9873 22.624 13.8144 22.624 13.6011C22.624 13.3878 22.4511 13.2148 22.2378 13.2148C22.0245 13.2148 21.8516 13.3878 21.8516 13.6011C21.8516 13.8144 22.0245 13.9873 22.2378 13.9873Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M21.4644 16.3032C21.6777 16.3032 21.8506 16.1303 21.8506 15.917C21.8506 15.7037 21.6777 15.5308 21.4644 15.5308C21.251 15.5308 21.0781 15.7037 21.0781 15.917C21.0781 16.1303 21.251 16.3032 21.4644 16.3032Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M22.2378 17.0747C22.4511 17.0747 22.624 16.9018 22.624 16.6885C22.624 16.4752 22.4511 16.3022 22.2378 16.3022C22.0245 16.3022 21.8516 16.4752 21.8516 16.6885C21.8516 16.9018 22.0245 17.0747 22.2378 17.0747Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M22.2378 15.5313C22.4511 15.5313 22.624 15.3583 22.624 15.145C22.624 14.9317 22.4511 14.7588 22.2378 14.7588C22.0245 14.7588 21.8516 14.9317 21.8516 15.145C21.8516 15.3583 22.0245 15.5313 22.2378 15.5313Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.5337 11.2844C19.5337 11.071 19.3607 10.8984 19.1477 10.8984C18.9346 10.8984 18.7617 11.071 18.7617 11.2844V12.0564H14.5156V18.2325H16.922L16.1148 19.5777C16.0052 19.7607 16.0643 19.9977 16.2472 20.1073C16.309 20.1448 16.3777 20.1625 16.4453 20.1625C16.5765 20.1625 16.7043 20.0957 16.7764 19.9753L17.8221 18.2325H20.4732L21.5189 19.9753C21.5911 20.0957 21.7188 20.1625 21.8501 20.1625C21.9176 20.1625 21.9863 20.1448 22.0485 20.1073C22.2315 19.9977 22.2905 19.7607 22.1809 19.5777L21.3734 18.2325H23.7797V12.0564H19.5337V11.2844ZM21.0777 12.8285C21.0777 13.0415 21.2506 13.2145 21.4637 13.2145C21.6768 13.2145 21.8497 13.0415 21.8497 12.8285H22.6217C22.6217 13.0415 22.7946 13.2145 23.0077 13.2145V13.9865C22.7946 13.9865 22.6217 14.1594 22.6217 14.3725C22.6217 14.5855 22.7946 14.7585 23.0077 14.7585V15.5305C22.7946 15.5305 22.6217 15.7034 22.6217 15.9165C22.6217 16.1296 22.7946 16.3025 23.0077 16.3025V17.0745C22.7946 17.0745 22.6217 17.2474 22.6217 17.4605H21.8497C21.8497 17.2474 21.6768 17.0745 21.4637 17.0745C21.2506 17.0745 21.0777 17.2474 21.0777 17.4605H20.3057C20.3057 17.2474 20.1328 17.0745 19.9197 17.0745C19.7066 17.0745 19.5337 17.2474 19.5337 17.4605H18.7617C18.7617 17.2474 18.5887 17.0745 18.3757 17.0745C18.1626 17.0745 17.9897 17.2474 17.9897 17.4605H17.2177C17.2177 17.2474 17.0447 17.0745 16.8316 17.0745C16.6186 17.0745 16.4456 17.2474 16.4456 17.4605H15.6736C15.6736 17.2474 15.5007 17.0745 15.2876 17.0745V16.3025C15.5007 16.3025 15.6736 16.1296 15.6736 15.9165C15.6736 15.7034 15.5007 15.5305 15.2876 15.5305V14.7585C15.5007 14.7585 15.6736 14.5855 15.6736 14.3725C15.6736 14.1594 15.5007 13.9865 15.2876 13.9865V13.2145C15.5007 13.2145 15.6736 13.0415 15.6736 12.8285H16.4456C16.4456 13.0415 16.6186 13.2145 16.8316 13.2145C17.0447 13.2145 17.2177 13.0415 17.2177 12.8285H17.9897C17.9897 13.0415 18.1626 13.2145 18.3757 13.2145C18.5887 13.2145 18.7617 13.0415 18.7617 12.8285H19.5337C19.5337 13.0415 19.7066 13.2145 19.9197 13.2145C20.1328 13.2145 20.3057 13.0415 20.3057 12.8285H21.0777Z",
          fill: "white",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }